import { z } from 'zod/v4';

import type { InfinexMessageNamespace } from './base';
import { targetTypeSchema } from './base';

import { errorEnvelopeSchema } from '../errors';

/**
 * No Solana‐wallet methods defined yet—map was empty.
 */
export const SolanaWalletMethods = [] as const;
const namespace: InfinexMessageNamespace = 'solana-wallet';

// (No schemas to export because there are no methods in the original map.)
export const solanaWalletRequestParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.string(),
  data: z.any(),
  timeoutMs: z.number().optional(),
});

export const solanaWalletResponseParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.string(),
  requestId: z.string(),
  response: z.any(),
  error: z.optional(z.unknown()),
});

export const solanaWalletNotificationParamsSchema = z.object({
  namespace: z.literal(namespace),
  target: targetTypeSchema,
  method: z.string(),
  data: z.any(),
});

export const solanaWalletRequestPassthroughSchema = z.object({
  type: z.literal('solana-wallet:request'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  requestId: z.string(),
  method: z.string(), // any JSON-RPC method
  data: z.any(), // arbitrary params
});

export const solanaWalletResponsePassthroughSchema = z.object({
  type: z.literal('solana-wallet:response'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  requestId: z.string(),
  method: z.string(),
  response: z.any(),
  error: z.optional(errorEnvelopeSchema),
});

export const solanaWalletNotificationPassthroughSchema = z.object({
  type: z.literal('solana-wallet:notification'),
  from: targetTypeSchema,
  to: targetTypeSchema,
  timestamp: z.string(),
  method: z.string(),
  data: z.any(),
});
